import {Component, Input, OnInit} from '@angular/core';
import {TourService} from '../services/tour.service';
import {TourApiService} from '../services/tour-api.service';
import {EnumAware, SocialWidget} from '../decorators/enum-aware.decorator';

@Component({
  selector: 'gt-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.css']
})
@EnumAware
export class SocialComponent implements OnInit {

  SocialWidget = SocialWidget;
  @Input() widgetType: SocialWidget;
  shareTitle: string;
  shareImageURL: string;
  shareSiteName: string;
  shareURL: string;
  shareEmailBody: string;

  constructor(private apiService: TourApiService, private tourService: TourService) { }

  ngOnInit() {
    this.shareTitle =  encodeURIComponent(this.tourService.tour.modelInfo.builder + ' - ' + this.tourService.tour.modelInfo.modelName);
    this.shareImageURL = this.apiService.socialImageURL();
    this.shareSiteName = this.tourService.tour.modelInfo.builder;
    this.shareURL = encodeURI(this.apiService.goTourResourceWithBuilderModelPath());
    this.shareEmailBody = 'See the interactive tour here: ' + this.shareURL;
    // console.log(this.shareImageURL);
  }

  encode(url: string): string {
    return encodeURIComponent(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/social.component.ts